export default "﻿<h3>DatePicker</h3>\n\n<p>Dokumentation fuer DatePicker</p>"